var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoveredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FB7B33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5833 7.91659C12.5833 7.59442 12.3221 7.33325 12 7.33325C11.6778 7.33325 11.4166 7.59442 11.4166 7.91659V11.4166H7.91665C7.59448 11.4166 7.33331 11.6778 7.33331 11.9999C7.33331 12.3221 7.59448 12.5833 7.91665 12.5833H11.4166V16.0833C11.4166 16.4054 11.6778 16.6666 12 16.6666C12.3221 16.6666 12.5833 16.4054 12.5833 16.0833V12.5833H16.0833C16.4055 12.5833 16.6666 12.3221 16.6666 11.9999C16.6666 11.6778 16.4055 11.4166 16.0833 11.4166H12.5833V7.91659Z",
    fill: "#131111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoveredIcon);
export default __webpack_public_path__ + "static/media/hovered-icon.a45fc75b411fbae6733c718ef66e8c6b.svg";
export { ForwardRef as ReactComponent };